import { Link, SectionHeader, Typography } from 'web-library';
import React from 'react';
import { useTOCStyles } from '../../../pages/helpdesk/TermsOfUse';

const PrivacyPolicyTermsOfUse = () => {
  const { classes } = useTOCStyles();

  return (
    <>
      <SectionHeader title="Privacy Policy" />
      <ol start={5}>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            Review this Web Site{' '}
            <Link href="/privacy-statement" withUnderline>
              Privacy Statement
            </Link>
          </Typography>
        </li>
      </ol>
    </>
  );
};

export default PrivacyPolicyTermsOfUse;
